import { LabeledSwitch } from "@cirrus/ui-kit/src/components/atoms/labeled-switch/index.jsx"
import { defaultTo } from "ramda"
import React from "react"
import { setLocalStorageValues, TableLocalStorageKey } from "../../helpers"

import { useTableContext } from "../../provider"

export const ColumnSwitch = (props) => {

  const { field, headerName, index, isLocked } = props

  const ctx = useTableContext()

  const onChange = (event) => {
    event.stopPropagation()
    ctx.columns.api.setState((prevState) => {
      const visibility = {
        ...prevState.visibility,
        [field]: !prevState.visibility[field]
      }

      setLocalStorageValues(
        ctx.props.tableId,
        TableLocalStorageKey.visibleColumns,
        visibility)

      return {
        ...prevState,
        visibility
      }
    })
  }

  return (
    <LabeledSwitch
      label={headerName || field}
      disabled={isLocked || index === 0}
      checked={defaultTo(false, ctx.columns.state.visibility[field])}
      onChange={onChange}
    />
  )
}
